import React from 'react';
import classnames from 'classnames';
import { Color } from 'swag-client-common/components/ui/color';
import productDetailsClasses from 'swag-client-common/styles/product-details.scss';
import { Toggle } from '../../../../../ui/toggle';
import classes from './choose-color.scss';
export const ChooseColorComponent = ({
  number,
  colors,
  isSplitOrderModeOn,
  isSplitOrderToggleShown,
  splitColorsTooltip,
  title,
  isLimitedEdition,
  onColorClick,
  onSplitOrderClick
}) => {
  const handleSplitOrderClick = value => {
    onSplitOrderClick(value);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: productDetailsClasses.block
  }, /*#__PURE__*/React.createElement("h5", {
    className: productDetailsClasses.blockTitle
  }, /*#__PURE__*/React.createElement("span", {
    className: productDetailsClasses.number
  }, number), /*#__PURE__*/React.createElement("span", {
    className: productDetailsClasses.onlyMobile
  }, "Select colors"), /*#__PURE__*/React.createElement("span", {
    className: productDetailsClasses.onlyTabletOrDesktopDesktop
  }, title || 'Choose your colors')), isSplitOrderToggleShown && /*#__PURE__*/React.createElement("div", {
    className: productDetailsClasses.buttonContainerRight
  }, /*#__PURE__*/React.createElement(Toggle, {
    tooltipClassName: productDetailsClasses.tooltip,
    uncheckedLabel: "Multiple colors:",
    tooltipText: splitColorsTooltip,
    value: isSplitOrderModeOn,
    "data-button": "Split",
    toggleBackgroundClassName: classnames(classes.toggleBackground, {
      [classes.toggleBackgroundOrange]: isLimitedEdition
    }),
    onToggle: () => handleSplitOrderClick(!isSplitOrderModeOn)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.colorContainer
  }, colors.map(({
    color,
    isActive,
    name,
    isHidden,
    isDisabled,
    index
  }) => {
    if (isHidden) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Color, {
      name: name,
      key: name,
      color: color,
      isActionable: !isDisabled,
      isActive: isActive && !isDisabled,
      isLimitedEdition: isLimitedEdition,
      tooltipText: isDisabled ? 'Out of stock' : name,
      className: classnames({
        [classes.disabled]: isDisabled
      }),
      onClick: () => !isDisabled && onColorClick({
        colorIndex: index,
        colorValue: color
      }, isActive),
      showTooltip: true
    });
  })));
};